/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { BeamConstancyWorkItemDto } from './BeamConstancyWorkItemDto';
import {
    instanceOfBeamConstancyWorkItemDto,
    BeamConstancyWorkItemDtoFromJSON,
    BeamConstancyWorkItemDtoFromJSONTyped,
    BeamConstancyWorkItemDtoToJSON,
} from './BeamConstancyWorkItemDto';
import type { ManualTaskWorkItemDto } from './ManualTaskWorkItemDto';
import {
    instanceOfManualTaskWorkItemDto,
    ManualTaskWorkItemDtoFromJSON,
    ManualTaskWorkItemDtoFromJSONTyped,
    ManualTaskWorkItemDtoToJSON,
} from './ManualTaskWorkItemDto';
import type { TrackItTaskWorkItemDto } from './TrackItTaskWorkItemDto';
import {
    instanceOfTrackItTaskWorkItemDto,
    TrackItTaskWorkItemDtoFromJSON,
    TrackItTaskWorkItemDtoFromJSONTyped,
    TrackItTaskWorkItemDtoToJSON,
} from './TrackItTaskWorkItemDto';

/**
 * @type WorkItemDto
 * 
 * @export
 */
export type WorkItemDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.BeamConstancyWorkItemDto, Ptw.Ptw100.AppZero.Application.Shared' } & BeamConstancyWorkItemDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualTaskWorkItemDto, Ptw.Ptw100.AppZero.Application.Shared' } & ManualTaskWorkItemDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.TrackItTaskWorkItemDto, Ptw.Ptw100.AppZero.Application.Shared' } & TrackItTaskWorkItemDto;


export function WorkItemDtoFromJSON(json: any): WorkItemDto {
    return WorkItemDtoFromJSONTyped(json, false);
}

export function WorkItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkItemDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.BeamConstancyWorkItemDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, BeamConstancyWorkItemDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.BeamConstancyWorkItemDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualTaskWorkItemDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, ManualTaskWorkItemDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualTaskWorkItemDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.TrackItTaskWorkItemDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TrackItTaskWorkItemDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.TrackItTaskWorkItemDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of WorkItemDto exists with '$type=${json['$type']}'`);
    }
}

export function WorkItemDtoToJSON(value?: WorkItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.BeamConstancyWorkItemDto, Ptw.Ptw100.AppZero.Application.Shared':
            return BeamConstancyWorkItemDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualTaskWorkItemDto, Ptw.Ptw100.AppZero.Application.Shared':
            return ManualTaskWorkItemDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.TrackItTaskWorkItemDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TrackItTaskWorkItemDtoToJSON(value);
        default:
            throw new Error(`No variant of WorkItemDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the WorkItemDto interface.
 */
export function instanceOfWorkItemDto(value: any): value is WorkItemDto {
    if (instanceOfBeamConstancyWorkItemDto(value)) return true;
    if (instanceOfManualTaskWorkItemDto(value)) return true;
    if (instanceOfTrackItTaskWorkItemDto(value)) return true;
    return false;
}

